import { render } from "./СallbackForm.vue?vue&type=template&id=311f2cdf"
import script from "./СallbackForm.vue?vue&type=script&lang=js"
export * from "./СallbackForm.vue?vue&type=script&lang=js"

import "./СallbackForm.vue?vue&type=style&index=0&id=311f2cdf&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__